import React, { useState } from "react";

import { RotaCheckbox } from "@teamrota/rota-design";

import styles, { Field, Label, Row, StyledErrorMessage } from "./styles";

const ServiceAreas = ({
  errors,
  initialValues,
  serviceAreas,
  setServiceAreas,
  inEditMode
}) => {
  const [checkedAreas, setCheckedAreas] = useState(
    initialValues?.serviceAreas || []
  );

  /**
   * Handle checkbox change and update checked service area array
   * @param {string} id service area id
   * @param {boolean} checked checkbox checked or not (add or remove id from array)
   */
  const handleCheckbox = (id, checked) => {
    let updatedCheckedAreas;

    if (checked) {
      updatedCheckedAreas = [...checkedAreas, id];
    } else {
      updatedCheckedAreas = checkedAreas.filter(item => item !== id);
    }
    setCheckedAreas(updatedCheckedAreas);
    setServiceAreas(updatedCheckedAreas);
  };

  return (
    <>
      <Row>
        <Field>
          <Label>Service Area</Label>
          {serviceAreas?.map(serviceArea => (
            <Label key={serviceArea.id}>
              <RotaCheckbox
                key={serviceArea.id}
                onClick={e =>
                  handleCheckbox(serviceArea.id, e.currentTarget.checked)
                }
                isDisabled={!inEditMode}
                isChecked={checkedAreas.includes(serviceArea.id)}
                style={styles.Checkbox}
                label={serviceArea.name}
              />
            </Label>
          ))}
          <StyledErrorMessage>{errors.serviceArea?.message}</StyledErrorMessage>
        </Field>
      </Row>
    </>
  );
};
export default ServiceAreas;
